import { Link } from "react-router-dom";
import {
  Grid,
  Typography,
  Link as MUILink,
  useTheme,
  List,
  ListItem,
} from "@mui/material";

import { getFooterRoutes } from "@/utils/getFooterRoutes";
import useResponsive from "@/hooks/useResponsive";
import { getFooterLinkStyles } from "../styles";

const FooterLinks = () => {
  const isTablet = useResponsive("down", "md");
  const footerRoutes = getFooterRoutes(isTablet);
  const theme = useTheme();

  return (
    <>
      {footerRoutes.map(({ title, routes }, index) => (
        <Grid key={index} item xs={6} sm={4} md={2.5} lg={2}>
          <Typography
            variant="subtitle1"
            component="p"
            fontWeight={700}
            color="white"
            mb={{ xs: 1, md: 2.75 }}
          >
            {title}
          </Typography>
          <List disablePadding>
            {routes.map(({ path, title }) => (
              <ListItem key={path} disablePadding>
                <MUILink
                  key={path}
                  component={Link}
                  to={path}
                  sx={getFooterLinkStyles(theme)}
                >
                  <Typography
                    variant="subtitle1"
                    component="span"
                    color="inherit"
                    textTransform="capitalize"
                  >
                    {title}
                  </Typography>
                </MUILink>
              </ListItem>
            ))}
          </List>
        </Grid >
      ))}
    </>
  );
};

export default FooterLinks;
